import { useContext } from 'react';
import { AppContext } from 'components/AppContextProvider/AppContextProvider';
import { FreecodeContext } from 'components/FreecodeContextProvider/FreecodeContextProvider';
import { FreecodeCreatorContext } from 'user/containers/FreecodeCreator/FreecodeCreator';

export const useAppContext = () => useContext(AppContext);

export const useFreecodeContext = () => useContext(FreecodeContext);

export const useFreecodeCreatorContext = () => useContext(FreecodeCreatorContext);
